import { FunctionComponent } from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'

import { AuthRoles } from 'common/types/'
import { useAuth } from 'pages/auth/hooks/useAuth'

interface PrivateRouteProps extends RouteProps {
  allowRoles: Array<AuthRoles>
  redirectTo?: string
  children: any
}

export const PrivateRoute: FunctionComponent<PrivateRouteProps> = ({
  allowRoles,
  redirectTo = '/authenticate',
  children,
  ...rest
}) => {
  const { backendUser, isAuthenticated, setForwardingUrl, forwardingUrl } = useAuth()
  const savePath = () => {
    switch(location?.pathname) {
      case '/search': 
        setForwardingUrl(`${location?.pathname}?name=&city=&company=&country=`)
        break
      case '/': 
        break 
      case '/settings':
        break
      case '/settings/partner':
        break
      default: 
          setForwardingUrl(`${location?.pathname}${location?.search}`)
        break
    }
  }

  const renderRoute = ({ location }) => {
    const doRedirect = (to: string) => {
      savePath()
      
      return (
        <Redirect
          to={{
            pathname: to,
            state: { from: location }
          }}
        />
      )
    }

    // @ts-ignore
    if (isAuthenticated && allowRoles.includes(backendUser?.role)) {
      return children
    } else {
      return doRedirect(redirectTo)
    }
  }

  return <Route {...rest} render={renderRoute} />
}
